export function listarMesesAnosEntreCompetencias(competenciaInicio, competenciaFim) {
  const competenciaInicioString = String(competenciaInicio)
  const competenciaFimString = String(competenciaFim)
    //exemplo de parâmetro = listarMesesAnosEntreCompetencias("02/2023", "01/2025"),
    //exemplo retorno:
    //[
    //  { mes: '02', ano: '2023' },
    //  { mes: ... , ano:   ...  },
    //  { mes: '01', ano: '2025' }
    //]
    const mes_inicio = competenciaInicioString.includes("/") ? competenciaInicioString.split("/")[0] : competenciaInicioString.substring(4, 6);
    const ano_inicio = competenciaInicioString.includes("/") ? competenciaInicioString.split("/")[1] : competenciaInicioString.substring(0, 4);
    const mes_fim = competenciaFimString.includes("/") ? competenciaFimString.split("/")[0] : competenciaFimString.substring(4, 6);
    const ano_fim = competenciaFimString.includes("/") ? competenciaFimString.split("/")[1] : competenciaFimString.substring(0, 4);
    let competenciaInicioInt = parseInt(ano_inicio + mes_inicio);
    const competenciaFimAno = parseInt(ano_fim + mes_fim);

    const competencias = [];
    while (competenciaInicioInt <= competenciaFimAno) {
        const mes = String(competenciaInicioInt).substring(4, 6);
        const ano = String(competenciaInicioInt).substring(0, 4);
        competencias.push({ mes, ano });
        if (parseInt(mes) < 12) {
            const mesIncrementado = parseInt(mes) + 1;
            competenciaInicioInt = ano + (mesIncrementado < 10 ? "0" + mesIncrementado : mesIncrementado);
        } else {
            const anoIncrementado = parseInt(ano) + 1;
            competenciaInicioInt = anoIncrementado + "01";
        }
    }
    return competencias;
}
